import { Component }      from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  template: require('./quickbooks.disclaimer.component.html')
})
export class QuickbooksDisclaimerComponent {
  constructor (
    public activeModal: NgbActiveModal
  ) {}
}
